<template>
  <div>
    <input
      :value="playlist.name"
      class="input title"
      type="text"
      placeholder="Name"
      @input="updateName($event.target.value)"
    >
    <b-field
      v-if="!playlist || !playlist.id"
      label="Create from template :"
    >
      <b-autocomplete
        v-model="templateName"
        rounded
        :open-on-focus="true"
        :data="filteredTemplates"
        placeholder="Template name"
        icon="magnify"
        field="name"
        @select="updateTemplate($event)"
      >
        <template slot="empty">
          No results for {{ templateName }}
        </template>
      </b-autocomplete>
    </b-field>

    <div v-else>
      <draggable-playlist-items
        :has-delete="true"
        :draggable="true"
        @deleteItem="handleRemovePlaylistItem($event)"
        @itemClick="editPlaylistItem(playlist, $event)"
      />
      <router-link
        :to="{ path: '/playlists/' + playlist.id + '/new-item' }"
        class="button is-info"
      >
        <span>+</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { onBottom } from "src/services/infinite-loading";
import DraggablePlaylistItems from "../components/DraggablePlaylistItems";

export default {
  components: {
    DraggablePlaylistItems
  },
  data() {
    return {
      templateName: ""
    };
  },
  computed: {
    ...mapGetters({
      playlist: "selectedPlaylist",
      playlistItems: "playlistItems"
    }),
    filteredTemplates() {
      return this.list.filter(template => {
        return template.name
          .toLowerCase()
          .includes(this.templateName.toLowerCase());
      });
    },
    ...mapState("playlistTemplates", ["current", "list"])
  },
  mounted() {
    this.fetchTemplates();
    if (this.playlist.id) {
      this.$store.dispatch("loadMorePlaylistItems");
      onBottom(() => {
        this.$store.dispatch("loadMorePlaylistItems");
      });
    }
  },
  methods: {
    updateName(value) {
      this.update("name", value);
    },
    updateTemplate(value) {
      let val = null;
      if (value && value.id) val = value.id;
      this.update("template_id", val);
    },
    update(path, value) {
      this.$emit("update", {
        path,
        value
      });
    },
    editPlaylistItem(playlist, item) {
      this.setPlaylistItem(item);
      this.$router.push({
        name: "edit-playlist-item",
        params: { playlistId: playlist.id, playlistItemId: item.id }
      });
    },
    handleRemovePlaylistItem(item) {
      this.removePlaylistItem({
        playlistId: this.playlist.id,
        playlistItemId: item.id
      });
    },
    ...mapActions(["selectPlaylistItem", "removePlaylistItem"]),
    ...mapActions("playlistTemplates", ["fetchTemplates"]),
    ...mapActions(["setPlaylistItem"])
  }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// PlaylistEdit.vue?1cb55bfa